import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import RequireAuth from './components/RequireAuth';
import GlobalLayout from './components/layout/GlobalLayout';
import LoginPage from './pages/auth/LoginPage';
import WikiHomePage from './pages/wiki/WikiHomePage';
import WikiPageViewPage from './pages/wiki/WikiPageViewPage';
import WikiPageFormPage from './pages/wiki/WikiPageFormPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public routes (no authentication required) */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protected routes (authentication required) */}
        <Route element={<RequireAuth />}>
          <Route element={<GlobalLayout />}>
            <Route path="/" element={<WikiHomePage />} />
            <Route path="/wiki/new" element={<WikiPageFormPage />} />
            <Route path="/wiki/:pageId" element={<WikiPageViewPage />} />
            <Route path="/wiki/:pageId/edit" element={<WikiPageFormPage />} />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
